import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import CardMedia from '@mui/material/CardMedia';
import Fade from '@mui/material/Fade';
import PropTypes from 'prop-types';
import { buildCdnUrl } from '../../helpers';
import { STACK_CENTER } from '../../constants/mui-components';

function VideoCard({ video }) {
  const [started, setStarted] = useState(false);
  const imageUrl = buildCdnUrl(video.imageResource, {
    format: 'webp',
    quality: 80,
  });

  return (
    <Stack
      className={STACK_CENTER}
      onClick={() => { window.open(video.src, '_blank', 'noopener,noreferrer'); }}
      sx={{
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        borderRadius: '0.75rem',
        maxWidth: '56rem',
        transition: 'transform 0.3s ease-in-out',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    >
      <Fade in={started} timeout={2000}>
        <CardMedia
          component="img"
          onLoad={() => setStarted(true)}
          image={imageUrl}
          alt={`corporative-video-${video.id}`}
          style={{
            objectFit: 'cover',
            width: '100%',
            borderRadius: '0.75rem',
          }}
        />
      </Fade>
    </Stack>
  );
}

VideoCard.propTypes = {
  video: PropTypes.shape({
    id: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
    imageResource: PropTypes.string.isRequired,
  }).isRequired,
};

export default VideoCard;
